/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { Configuration } from '../configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiInvitesActivatePost } from '../fn/invites/api-invites-activate-post';
import { ApiInvitesActivatePost$Params } from '../fn/invites/api-invites-activate-post';
import { apiInvitesInviteIdPut } from '../fn/invites/api-invites-invite-id-put';
import { ApiInvitesInviteIdPut$Params } from '../fn/invites/api-invites-invite-id-put';
import { apiInvitesInviteIdRevokePost } from '../fn/invites/api-invites-invite-id-revoke-post';
import { ApiInvitesInviteIdRevokePost$Params } from '../fn/invites/api-invites-invite-id-revoke-post';
import { apiInvitesPost } from '../fn/invites/api-invites-post';
import { ApiInvitesPost$Params } from '../fn/invites/api-invites-post';
import { apiInvitesSpaceSpaceIdGet } from '../fn/invites/api-invites-space-space-id-get';
import { ApiInvitesSpaceSpaceIdGet$Params } from '../fn/invites/api-invites-space-space-id-get';
import { CreateResult } from '../models/create-result';
import { InviteDto } from '../models/invite-dto';


/**
 * Invite management
 */
@Injectable({ providedIn: 'root' })
export class InvitesService extends BaseService {
  constructor(config: Configuration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiInvitesSpaceSpaceIdGet()` */
  static readonly ApiInvitesSpaceSpaceIdGetPath = '/api/Invites/space/{spaceId}';

  /**
   * Get all invites for a space.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInvitesSpaceSpaceIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInvitesSpaceSpaceIdGet$Response(params: ApiInvitesSpaceSpaceIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<InviteDto>>> {
    const obs = apiInvitesSpaceSpaceIdGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all invites for a space.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiInvitesSpaceSpaceIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInvitesSpaceSpaceIdGet(params: ApiInvitesSpaceSpaceIdGet$Params, context?: HttpContext): Observable<Array<InviteDto>> {
    const resp = this.apiInvitesSpaceSpaceIdGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<InviteDto>>): Array<InviteDto> => r.body)
    );
  }

  /** Path part for operation `apiInvitesPost()` */
  static readonly ApiInvitesPostPath = '/api/Invites';

  /**
   * Send an invite to an email address.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInvitesPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiInvitesPost$Response(params?: ApiInvitesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateResult>> {
    const obs = apiInvitesPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Send an invite to an email address.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiInvitesPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiInvitesPost(params?: ApiInvitesPost$Params, context?: HttpContext): Observable<CreateResult> {
    const resp = this.apiInvitesPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CreateResult>): CreateResult => r.body)
    );
  }

  /** Path part for operation `apiInvitesActivatePost()` */
  static readonly ApiInvitesActivatePostPath = '/api/Invites/activate';

  /**
   * Activate an invite by token.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInvitesActivatePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiInvitesActivatePost$Response(params?: ApiInvitesActivatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiInvitesActivatePost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Activate an invite by token.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiInvitesActivatePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiInvitesActivatePost(params?: ApiInvitesActivatePost$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiInvitesActivatePost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiInvitesInviteIdRevokePost()` */
  static readonly ApiInvitesInviteIdRevokePostPath = '/api/Invites/{inviteId}/revoke';

  /**
   * Revoke an invite.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInvitesInviteIdRevokePost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInvitesInviteIdRevokePost$Response(params: ApiInvitesInviteIdRevokePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiInvitesInviteIdRevokePost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Revoke an invite.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiInvitesInviteIdRevokePost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInvitesInviteIdRevokePost(params: ApiInvitesInviteIdRevokePost$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiInvitesInviteIdRevokePost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiInvitesInviteIdPut()` */
  static readonly ApiInvitesInviteIdPutPath = '/api/Invites/{inviteId}';

  /**
   * Update invite with user ID (after registration).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInvitesInviteIdPut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiInvitesInviteIdPut$Response(params: ApiInvitesInviteIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiInvitesInviteIdPut(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update invite with user ID (after registration).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiInvitesInviteIdPut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiInvitesInviteIdPut(params: ApiInvitesInviteIdPut$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiInvitesInviteIdPut$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
